import {Component, Input} from '@angular/core';
import {SubscriptionHistoryResponse} from "../../../models/subscriptionHistoryResponse";
import {SubscriptionType} from "../../../models/subscriptionType.enum";

@Component({
  selector: 'app-profile-subscription-history',
  templateUrl: './profile-subscription-history.component.html',
  styleUrls: ['./profile-subscription-history.component.css']
})
export class ProfileSubscriptionHistoryComponent {

  @Input() protected currentUserId!: string;

  private readonly pageContentMaxSize: number = 8;

  private pageCount: number = 0;
  private currentPage: number = 0;
  private contentSize: number = 0;

  // todo: rename and remove dummy values when api will be implemented
  protected readonly dummySubscriptionHistory: Array<SubscriptionHistoryResponse> = [
    {
      subscriptionId: 'someUUID1',
      type: SubscriptionType.BASIC,
      startDate: new Date("10/10/2020 12:23"),
      endDate: new Date("10/10/2030 23:10"),
    },
    {
      subscriptionId: 'someUUID2',
      type: SubscriptionType.PRO,
      startDate: new Date("10/10/2020 12:23"),
      endDate: new Date("10/10/2030 23:10"),
    },
    {
      subscriptionId: 'someUUID3',
      type: SubscriptionType.ENTERPRISE,
      startDate: new Date("10/10/2020 12:23"),
      endDate: new Date("10/10/2030 23:10"),
    },
  ]

  constructor() {
  }

  protected isItemsSizeMoreThanMaxSize(): boolean {
    // todo: implement when there is a pagination
    return this.contentSize > this.pageContentMaxSize;
  }

  protected downloadSubscriptionPDF(subscription: SubscriptionHistoryResponse) {
    alert('Not implemented yet');
    // todo: call api and download pdf
  }
}
